import BaseApi from './BaseApi';

type User = {
  chimeId: string;
  idToken: string;
  accessToken: string;
};

/**
 * LINEユーザーログインAPI。
 */
class LineLogInApi extends BaseApi {
  async login() {
    return await this.execute('lineLogInApi', {
      method: 'GET'
    }).then(({ result }) => result as User);
  }
}

export default LineLogInApi;
